import React, { useEffect, useState } from 'react';
import { IonButton, IonCol, IonContent, IonHeader, IonInput, IonPage, IonRow } from '@ionic/react';
import { Redirect } from 'react-router-dom';
import { Toolbar } from './Toolbar';
import { useAuthentication } from '../authentication/authentication-hook';
import { authenticate } from '../authentication/legacy';
import { useKeycloakFeatureFlag } from '../authentication/AuthenticationFeatureSwitch';
import { isTest } from "../utilities/api";

const removeTestPrefixInTestEnv = (username) => {
    if (isTest()) {
        return username.replace(/^test_/, '');
    }
    return username;
};

/** @deprecated */
export default function LogIn({ history, location }) {
    const {
        isAuthenticated,
        login,
    } = useAuthentication();

    const keycloakFeatureFlag = useKeycloakFeatureFlag();

    useEffect(() => {
        if (keycloakFeatureFlag.useLegacy) {
            // Nothing to do in legacy, we already are in the right place to login.
            return;
        }

        if (!isAuthenticated) {
            login({
                redirectUri: window.location.href,
            });
        }
    }, [ isAuthenticated, keycloakFeatureFlag.useLegacy, login ]);

    function LegacyLoginPanel() {

        const [ error, setError ] = useState(undefined);

        const submitLogin = async (e) => {
            e.preventDefault();

            try {
                const {
                    username: { value: username },
                    password: { value: password },
                } = e.currentTarget;

                if (username?.length < 4) {
                    setError(`Username too short`);
                    return;
                }

                if (password?.length < 4) {
                    setError(`Password too short`);
                    return;
                }

                const user = await authenticate(removeTestPrefixInTestEnv(username), password);

                if (user === undefined) {
                    setError('Invalid username/password');
                    return;
                }

                // Signal to the general auth provider that we've logged in with legacy.
                return login({
                    user,
                    isAuthenticatedViaLegacyPath: true,
                });
            } catch (error) {
                setError("Something went wrong while trying to log in.");
            }
        };

        return (
            <form method={ 'POST' } onSubmit={ submitLogin }>
                <IonRow>
                    <IonCol>
                        <div className="ion-text-center">
                            <h3>Sign in to continue</h3>
                        </div>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol>
                        <IonInput
                            padding-horizontal
                            placeholder="Username"
                            className="input"
                            name={ 'username' }
                        />
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol>
                        <IonInput
                            placeholder="Password"
                            type="password"
                            className="input"
                            name={ 'password' }
                        />
                    </IonCol>
                </IonRow>

                { error &&
                    <IonRow>
                        <IonCol>
                            { error }
                        </IonCol>
                    </IonRow>
                }

                <IonRow>
                    <IonCol>
                        <IonButton type="submit" expand="block">Login</IonButton>
                        <IonButton
                            type="button"
                            color="medium"
                            onClick={ () => history.push('/resetpassword') }
                            expand="block"
                        >Reset Password</IonButton>
                    </IonCol>
                </IonRow>
            </form>
        );
    }

    const from = location?.state?.from;
    const redirectToPage = from && !from.startsWith('/login') ? from : '/';

    if (isAuthenticated) {
        return (<Redirect to={ redirectToPage }/>);
    }

    return (
        <IonPage>
            <IonHeader>
                <Toolbar title="Sign In" />
            </IonHeader>
            <IonContent className="ion-padding">
                <LegacyLoginPanel/>
            </IonContent>
        </IonPage>
    );
}

